import { Box, Typography } from '@mui/material';
import { MaintenanceActivatedBy } from '../../types/site';
import { SpannerIcon } from 'src/assets/icons/SpannerIcon';

const getActivatedByLabel = (activatedBy: MaintenanceActivatedBy): string => {
  if (activatedBy.type === 'System') return 'System';
  return activatedBy.email;
};

interface Props {
  activatedBy: MaintenanceActivatedBy;
}

export const MaintenanceBanner = ({ activatedBy }: Props) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      px: 2,
      py: 0.75,
      borderRadius: '8px',
      backgroundColor: '#E3F2FD',
      border: '1px solid #90CAF9',
    }}
    data-sm="maintenance-mode-banner"
  >
    <SpannerIcon width={15} fill="#1565C0" />
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 600, color: '#1565C0', lineHeight: 1.3 }}>
        Maintenance Mode activated by {getActivatedByLabel(activatedBy)}.
      </Typography>
      <Typography variant="body2" sx={{ color: '#1565C0', lineHeight: 1.3 }}>
        All alarms are muted for this site.
      </Typography>
    </Box>
  </Box>
);
